import Box from '@mui/material/Box/Box'
import { useMemo } from 'react'

import { i18WithParams as t } from '@shared/locale'
import { SharedTable } from 'components-ui/src/table/table'
import type { HeadCell, Order, Row } from 'components-ui/src/table/table.d'
import { LocationServiceTypeClientDto, WaitlistOrderClientDto } from 'service-api/src/types/api'
import { PetsAndServiceType, waitlistVisitGridSx } from './childs/pets_and_service_type'
import { Status } from './childs/status'
import { SERVICE_DATES } from './helper'

const STATUS = 'status'

const headCellsLUP: HeadCell[] = [
  {
    id: SERVICE_DATES,
    label: (
      <Box sx={waitlistVisitGridSx}>
        <span>{t('profile.waitlist.table.visit')}</span>
        <span>{t('profile.waitlist.table.pets')}</span>
        <span>{t('profile.waitlist.table.visitDate')}</span>
      </Box>
    ),
    fullWidthLabel: true,
    sortable: true,
  },
  { id: STATUS, label: t('global.label.status'), align: 'center' },
]

interface Props {
  waitList: WaitlistOrderClientDto[]
  nextToken?: string | null
  onColumnSort: (field: string, order: Order, limit: number) => void
  serviceTypes: LocationServiceTypeClientDto[]
  isLoading: boolean
  onLoadMore: (limit: number, nextToken: string | null) => void
}

export const WaitListTableLup = ({ waitList, nextToken, serviceTypes, onColumnSort, isLoading, onLoadMore }: Props) => {
  const rows: Row[] = useMemo(() => {
    return waitList.map((item) => {
      return {
        [SERVICE_DATES]: <PetsAndServiceType order={item} serviceTypes={serviceTypes} />,
        [STATUS]: <Status order={item} />,
      }
    })
  }, [serviceTypes, waitList])

  return (
    <Box
      sx={{
        '& thead th:first-of-type > .MuiBox-root': {
          position: 'relative',
        },
        '& thead th:first-of-type > .MuiBox-root > svg': {
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          marginLeft: 0,
        },
      }}
    >
      <SharedTable
        rows={rows}
        head={headCellsLUP}
        defaultOrder="desc"
        defaultOrderBy={SERVICE_DATES}
        isLoading={isLoading}
        emptyTableMessage={t('profile.waitlist.table.empty')}
        hasMore={!!nextToken}
        showPagination={true}
        loadMore={(limit) => {
          if (nextToken) {
            onLoadMore(limit, nextToken)
          }
        }}
        onSort={onColumnSort}
      />
    </Box>
  )
}
